import React from 'react';
import { WidgetStrategyWithCustomManagedStream } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { SymbolTile } from 'widgets/symbolTile/components/SymbolTile';
import {
    initialSymbolTileConfigState,
    SymbolTileConfigState,
} from 'widgets/symbolTile/store/instances/config/SymbolTileConfigState';
import { symbolTileStreamConfig } from 'widgets/symbolTile/stream/stream-config';
import { symbolTileDescription } from 'widgets/symbolTile/components/description/symbolTileDescription';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import SymbolTileSettings from 'widgets/symbolTile/components/settings/SymbolTileSettings';
import { SymbolTileMyPortfolioCapsuleContent } from 'widgets/symbolTile/components/SymbolTileMyPortfolioCapsuleContent';
import { useSymbolMessages } from 'widgets/symbolTile/store/data/hooks';

export const symbolTileWidgetStrategy: WidgetStrategyWithCustomManagedStream &
    MyPortfolioCapsuleWidgetStrategyWithConfig<SymbolTileConfigState> = {
    title: 'Price',
    supportedHosts: ['tile'],
    reactComponentType: SymbolTile,
    myPortfolioCapsuleContentReactComponentType:
        SymbolTileMyPortfolioCapsuleContent,
    categories: [WidgetCategory.PRICE_CAPSULES],
    description: symbolTileDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
    initialConfigState: initialSymbolTileConfigState,
    managedStreamConfig: symbolTileStreamConfig,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    renderSettingsBody,
    useMessagesInMyPortfolioCapsules: useSymbolMessages,
};

function renderSettingsBody(
    config: SymbolTileConfigState,
    onChange: (configDelta: Partial<SymbolTileConfigState>) => void
) {
    return <SymbolTileSettings config={config} onChange={onChange} />;
}
